export default __webpack_public_path__ + "7ef62773101b87a70df9b703d9842a81.png";